"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Question = exports.SeedQuestion = exports.questions = exports.INDIVIDUAL_QUESTION_DEFINITIONS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const yup_database_adapter_1 = require("@visto-tech/yup-database-adapter");
const __1 = require("..");
const question_input_types_1 = require("../types/question-input-types");
// Format date like YYYY-MM-DD with validation for different months
// const DATE_VALIDATION_RULE = serialize((yup) =>
//   yup
//     .string()
//     .required("Please fill in the above question.")
//     .matches(
//       /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))/,
//       "Please make sure your date is formatted like: YYYY-MM-DD"
//     )
// );
exports.INDIVIDUAL_QUESTION_DEFINITIONS = [
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Apt or Unit number",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Apt or Unit number (Residential Address)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are there other work locations the job will take place in?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are they still living?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you a lawful Permanent Resident of the United States with a valid alient registration card (green card)?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you able to communication in English and/or French?",
        options: __1.langCommunicateCanadaTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you bringing any family members (spouse, common-law partner, children) with you to Canada?",
        options: __1.yesNoOptions,
        tip: "This can only be a current partner (spouse or common-law) or dependent children.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you, or have you ever been a member or associated with any political party, or other group or organization which has engaged in or advocated violence as a means to achieving political or religious objectiv, or which has been assoicated with criminal activity at the time?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Authorized Person First Name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Authorized Person Last Name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Authorized Person Phone Number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Business Phone Number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Business operating name where the job will take place",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "15-digit CRA Payroll Number",
        tip: "9 numbers then RP then 4 other numbers. Eg. 111222333RP0001",
        validationRules: (0, yup_database_adapter_1.serialize)((yup) => yup
            .string()
            .required("Please fill in the above question.")
            .matches(/([A-Z0-9]{9})RP([A-Z0-9]{4})/g, "Please ensure your CRA payroll number is correct, do not include any spaces. It should begin with 9 numbers, followed by RP, then 4 numbers. Example: 123456789RP1234")),
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "City or Town",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "City or Town (Residential Address)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "City/Town (Place of birth)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Company or Employer or Facility name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Country of Birth",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Country of Citizenship",
        options: __1.countryCitizenship,
        tip: "As shown on your passport",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Country or Territory",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Country or Territory (Residential Address)",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Country or Territory (Place of birth)",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Country or territory of issue",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Current country of residence",
        options: __1.countryResidenceOptionsTransformed,
        tip: "Where you are currently living right now.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Current country of residence from date",
        tip: "The date you started living in this country",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Current country of residence other status",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Current country of residence status",
        options: __1.residenceStatusOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Current country of residence to date",
        validationRules: null,
        tip: "The date you stopped living in this country (leave blank if you are still living there).",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Date Business Started",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Date of Birth",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Describe the main business activities that occur in this location",
        tip: "2 to 3 sentences max",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Did you serve in any military, militia, or civil defence unit or serve in a security organization or police force (including non obligatory national service, reserve or volunteer units)?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "District",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "District (Residential Address)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you currently have employees working in Canada in the same role and similar level of experience?",
        tip: "Same title, roughly same years of experience",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you currently live with the main applicant in this application (the primary applicant who is being sponsored to come to Canada)?",
        options: __1.yesNoOptions,
        tip: "Is your home address the same as the main applicant",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have a national identity document (NID)",
        tip: "These are only issued by certain countries so click “No” if not applicable to you",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have a partner (spouse or common-law) who is not part of this application?",
        options: __1.yesNoOptions,
        tip: "This is someone who is not coming to Canada with you at all.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have an alternate telephone to add?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have any additional parents to list?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have any other children that are not being included in this application or not coming with you to Canada?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have any physical or mental disorders that would require you social and/or health services, other than medication, during a stay in Canada?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Do you have any previous empoyments you would like to add?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you want to be the primary person of contact and can you sign on behalf of the company?",
        options: __1.yesNoOptions,
        tip: "Are you authorized to sign agreements on behalf of the company.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Does your business receive support through Employment and Social Development Canada’s work Sharing program?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "During the past five years have you lived in any country or territory other than your country of citizenship or your current country or territory of residence for more than six months?",
        options: __1.yesNoOptions,
        tip: "This would be any country that you lived in for a minimum of 6 months, continously, in the last 5 years, that is not either your country of citizenship or current country of residence.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Email address",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "End date",
        tip: "Leave empty if still working there",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Expiry date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Field and level of Study",
        tip: "Program name e.g. Bachelors of Science",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "First name(s)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "For this trip, will you use a National Israeli Passport",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "For this trip, will you use a passport issued by the Ministry of Foreign Affairs in Taiwan that includes your personal identification number?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Full name",
        tip: "This includes your first, middle and last name(s).",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Green Card Document number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Green Card Expiry date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you been approved for a GTS (Global Talent Stream) application in the last 2 years?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you ever been refused a visa or permit, denied entry or ordered to leave Canada or any other country or territory?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you ever commited, been arrested for, been charged with or convicted of any criminal offence in any country or territory?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you ever remained beyond the validity of your status, attended school without authorization or worked without authorization in Canada?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you ever used any other name?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you ever witnessed or participated in ill treatment of prisoners or civilians, looting or desecration of religious buidlings?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you had any post secondary education (including university, college or apprenticeship training)?",
        options: __1.yesNoOptions,
        tip: "Education completed after high school/secondary school only.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you lived any other country for 6 months or longer (continuously) in the last 12 months?",
        options: __1.yesNoOptions,
        tip: "In the last year, did you live somewhere else for a minimum of 6 months, consecutively.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you lived in your current country of residence for longer than 6 months?",
        options: __1.yesNoOptions,
        tip: "6 months consecutively, meaning you have not lived anywhere else for at least the last 6 months.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you previously applied to enter or remain in Canada?",
        options: __1.yesNoOptions,
        tip: "To someone not included in this application.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you previously been married or in a common-law relationship?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you taken a test from a designated testing agency to assess your proficiency in English or French?",
        tip: "Eg. IELTS. Note: this is not a requirement!",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you tried to recruit inside Canada for this role?",
        options: __1.yesNoOptions,
        tip: "Recruitment inside Canada is not a requirement.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadian citizens or permanent residents?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many employees are employed nationally under the CRA number listed above?",
        tip: "Full-time employees inside Canada",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many foreign workers?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many hours will they work per day?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many vacations days per year will be offered?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What's the overtime rate (per hour)?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "If you are married or in a common-law relationship, please provide the date on which you were married on entered into common-law relationship",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In the last 12 months, have you laid off any employees in this role?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "In which city was your father living when they passed?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "In which city was your mother living when they passed?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "In which city was your partner living when they passed?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "In which city were they living in when they passed?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In which country was your father living when they passed?",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In which country was your mother living when they passed?",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In which country was your partner living when they passed?",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In which country where they living in when they passed?",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In which language are you most at ease?",
        options: __1.canadianLangOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Incorporation or Business Identification Number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the position part of a union?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is there a labour dispute at any of the work locations?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is there any overtime being offered?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is this job offer for 30 or more hours per week?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your alternate telephone number in Canada or USA?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your country or territory where you are applying the same as your current country or territory of residence?",
        options: __1.yesNoOptions,
        tip: "Will you be applying from your official country of residence (e.g. your country of residence is India, but you are currently visiting the USA and don't intend on returning to India).",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your father still living?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your mother still living?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your partner (spouse or common-law) still living?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your residential address the same as your mailing address?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your telephone number in Canada or USA?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Issue date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Job Title",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Language requirement for the job",
        options: [
            { option: "English" },
            { option: "French" },
            { option: "English and French" },
            { option: "Other (please explain)" },
        ],
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Last name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Legal Business Name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Main duties of the job",
        tip: "3-4 short bullet points at maximum",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Marital status",
        options: __1.maritalStatus,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Minimum education requirements for the job",
        options: __1.educationRequirementsOther,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Minimum experience and skills required (include years of experience and/or occupation designations if required)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "NID Country or territory of issue",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "NID Document number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "NID Expiry date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "NID Issue date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "NOC code",
        tip: "This is a 4 digit number that coincides with the role you are applying for. If you don’t know the NOC code, leave it blank!",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Native language or Mother Tongue",
        options: __1.allLanguages,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "On what date did they pass?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "On what date did your father pass?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "On what date did your mother pass?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "On what date did your partner pass?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Organization Type and Structure",
        options: [
            { option: "Partnership" },
            { option: "Corporation" },
            { option: "Sole Proprietorship" },
            { option: "Co-Operative" },
            { option: "Non-Profit" },
            { option: "Registered Charity" },
        ],
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Other country from date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Other country or territory",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other country other status",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Other country status",
        options: __1.residenceStatusOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Other country to date",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other first name(s)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other language requirement",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other last name(s)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other minimum education requirement",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other work location Address",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other work location City",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other work location Postal Code",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Other work location Province",
        options: __1.canadianProvinces,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "P.O. Box",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Passport number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Phone number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Place of Incorporation or Business",
        tip: "City and country",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please explain how hiring for this role will cause layoffs",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please explain why this job offer is for less than 30 hours per week",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please explain your efforts for trying to recruiting inside Canada in 1-2 sentences",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide dates of service and countries or territories where you served",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details and the name of the family members (if applicable)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide more details",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Please select any benefits being offered:",
        options: __1.talentBenefits,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Current full address",
        tip: "This should include street number, street name, city, country, postal code, etc.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Present occupation",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Previous country from date",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Previous country or territory",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Previous country other status",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Previous country status",
        options: __1.residenceStatusOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Previous country to date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Previous spouse or common-law date of birth",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Previous spouse or common-law family name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Previous spouse or common-law from date",
        tip: "Date the marriage or common-law partnership started",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Previous spouse or common-law given name(s)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Previous spouse or common-law to date",
        tip: "Date the marriage or common-law partnership ended",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Previous spouse or common-law type of relationship",
        options: __1.maritalStatusPreviousTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Province or State",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Province or State (Residential Address)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Province",
        options: __1.canadianProvinces,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "School/Facility name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Sex",
        options: __1.genderOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Start date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Street name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Street name (Residential Address)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Street number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Street number (Residential Address)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Telephone number",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Telephone number (Alternate)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Telephone number country code",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Telephone number country code (Alternate)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Telephone number extension",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Telephone number extension (Alternate)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Telephone number type",
        options: __1.telephoneNumberType,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Telephone number type (Alternate)",
        options: __1.telephoneNumberType,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Type of Business or Activity",
        tip: "1-2 sentences max",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Vacation pay (as % of gross salary) if applicable",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Website URL",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "What are 2 activities you are already doing or can commit to doing for the next 2 years as a company?",
        options: __1.companyBusinessActivities,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What country did you live in, in the last 12 months (for 6 months or longer)?",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "For the employees inside Canada with the same office location, role and years of experience, what is the highest salary that you’re currently paying?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "For the employees inside Canada with the same office location, role and years of experience, what is the lowest salary that you're currently paying?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the annual gross revenue of the business (in $CAD)?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is the wage or salary?",
        tip: "Yearly base salary in Canadian dollars (CAD)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What other benefits are being offered",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "What was the reason for the layoff(s) (1-2 sentences)?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Why are they needed in Canada and what will they be working on while in Canada (1-2 sentences MAX)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will hiring for this role cause any layoffs or reduction in work of current employees?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Within the past two years, have you or a family member ever had tuberculosis of the lungs or have been in close contact with a person with tuberculosis?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Work location Address",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Work location City",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Work location Postal Code",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Postal code or ZIP code",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Postal code or ZIP code (Residential Address)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Work location Province",
        options: __1.canadianProvinces,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Your current marital status",
        options: __1.maritalStatus,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you a lawful Permanent Resident of the United States with a valid alien registration card (green card)?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will your child (other) be accompying you to Canada?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your mailing address different from your business address?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Apt or Unit number (Mailing Address)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Street number (Mailing Address)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Street name (Mailing Address)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "City or Town (Mailing Address)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Country or Territory (Mailing Address)",
        options: __1.countryResidenceOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Province or State (Mailing Address)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Postal code or ZIP code (Mailing Address)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.FAMILY_MEMBERS,
        question: "If you are bringing a spouse, common law partner and/or children with you to Canada, please add each of them here!",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.REPEATER_CHILD_INFO,
        question: "Please add all of your children who are not part of this application",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.REPEATER_EMPLOYMENT_INFO,
        question: "Please add your employment history and previous job information",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.REPEATER_PREVIOUS_RESIDENCE,
        question: "Please add your previous countries of residence",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Other partner (spouse or common-law)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Information about your Mother",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Information about your Father",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Additional parents",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Information about your Children",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have a second Country of Citizenship?",
        options: __1.yesNoOptions,
        tip: "I.e. a second passport",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Secondary Country of Citizenship",
        options: __1.countryCitizenship,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will the employee(s) be working at your primary business address?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Please include a link to the role/job description/job posting that lists the main duties and responsibilities",
        tip: "This can be from your company website, job board link, LinkedIn, Lever, etc.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "GitHub Profile URL",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "LinkedIn Profile URL",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What is their expected start date to begin working in Canada?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Which province is your study program located in?",
        options: __1.canadianProvinces,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is the name of the school or institution that you will be attending?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Level of study",
        options: __1.levelOfStudy,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Field of study",
        options: __1.fieldOfStudy,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "School street address",
        tip: "Only include the full street address, ex: 4535 Somewhere Road",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "School city or town",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "School province",
        options: __1.canadianProvinces,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total cost of tuition (CAD)",
        tip: "Total cost of tuition only, not including room and board, or other costs, in Canadian (CAD) dollars.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total cost of room and board (CAD)",
        validationRules: null,
        tip: "Total cost of your room and board, i.e. where you will be staying while in Canada and how much will that cost, in Canadian (CAD) dollars.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total other costs (CAD)",
        validationRules: null,
        tip: "Total of any other costs, not including tuition or room and board, in Canadian (CAD) dollars",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total funds available for duration of stay (CAD)",
        tip: "The total dollar amount of money you will have for your entire stay, in Canadian (CAD) dollars",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Who will pay for your expenses while in Canada?",
        options: __1.studyFundsPaidBy,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Who (other) will pay for your expenses while in Canada?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "School or program start date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "School or program end date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Designated Learning Institution number (O#)",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Student ID number",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.REPEATER_MILITARY_SERVICE,
        question: "Please provide all the details about your military service below",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.REPEATER_POLITICAL_GROUP,
        question: "Please provide all the details about your involvement with political parties or other organizations",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.REPEATER_PRISONER_TREATMENT,
        question: "Please provide all the details about your involvement with ill treatment of prisoners or civilians, looting or desecration of religious buidlings",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Postal Code",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Law Society Province",
        options: __1.canadianProvinces,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Law Society Membership ID #",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your business operating name different from your business legal name?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Business operating name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be traveling to Canada with both (or all) your parent(s) or legal guardian(s)?",
        options: __1.yesNoOptions,
        tip: "If you have 2 parents or legal guardians and are only traveling with one parent, or legal guardian, we require consent from the parent or legal guardian who is not traveling.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Where will you live (reside) while studying in Canada?",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Information about your primary parent or legal guardian",
        validationRules: null,
        tip: "You will require approval from at least one of your parents or legal guardians to travel to Canada",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Information about your secondary parent or legal guardian",
        validationRules: null,
        tip: "If you have a second parent or legal guardian, please add them as well",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Information about your custodian who is located in Canada",
        validationRules: null,
        tip: "If you are 18 or under and are traveling to Canada by yourself, you will require a Custodian that is located in Canada.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Status in Canada",
        options: __1.canadianStatus,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have another parent or legal guardian that you would like to add?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Birth certificate number",
        tip: "What is your birth certificate number or ID",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Birth certificate issuing Country",
        options: __1.countryResidenceOptionsTransformed,
        tip: "In what country was your birth certificate issued (what country were you born in)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "School postal code",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Please select the organization that applies to you",
        options: __1.legalRepresentativeOrganization,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "ICCRC Membership ID",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Chambre of Notaries of Quebec Membership ID",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other Third-Party Representative",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you 18 years of age or older?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What day will you be arriving?",
        tip: "What is your arrival date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What day will you be leaving?",
        tip: "What is your departure date?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the total amount of funds you have available for your visit?",
        tip: "How much money, in Canadian dollars (CAD) do you have availble for your stay in Canada?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Who will you be visiting while you are in Canada?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Full name of person or institution",
        tip: "Who (or what) will you be visiting in Canada?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "How do you know them?",
        tip: "What is your relationship with the person or the institution you are visiting?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is their full address in Canada?",
        tip: "Please include their full address, ex: 123 Somewhere Street, Toronto, Ontario G7H 8H7",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be visiting anyone else in while Canada?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be visiting Canada for longer than 6 months?",
        tip: "For this visit, will you be spending more than 6 months in Canada",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What type of work permit are you applying for?",
        options: __1.workPermitType,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is the name of your employer?",
        tip: "What is the name of the company you will be working for in Canada? If you are employed by a foreign employer who has been awarded a contract to provide services to a Canadian entity, please identify the foreign employer here.",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is the full address of your employer?",
        tip: "Please include their full address, ex: 123 Somewhere Street, Toronto, Ontario G7H 8H7. This can be a Canadian or foreign address",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Which province will you be working in?",
        options: __1.canadianProvinces,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is the address of where you will be working in Canada?",
        tip: "Please include the street number, name and type, ex: 123 Somewhere Street",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What will your job title be?",
        tip: "Ex: Software Engineer",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Can you provide a brief description of your job duties while working in Canada?",
        tip: "This should be 1 to 2 sentences, explaining what type of work you will be doing in Canada",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What day will you start working?",
        tip: "What is your first day of work in Canada?",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What day will you stop working?",
        tip: "What will be your last day of work in Canada?",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "LMIA # or Offer of Employment #",
        tip: "What is your Labour Market Impact Assessment (LMIA) number or Offer of Employment (LMIA Exempt) number?",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Alberta",
        options: __1.canadianCitiesLabelOnly.alberta,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in British Columbia",
        options: __1.canadianCitiesLabelOnly.britishColumbia,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Manitoba",
        options: __1.canadianCitiesLabelOnly.manitoba,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in New Brunswick",
        options: __1.canadianCitiesLabelOnly.newBrunswick,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Newfoundland",
        options: __1.canadianCitiesLabelOnly.newfoundland,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Northwest Territories",
        options: __1.canadianCitiesLabelOnly.northwestTerritories,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Nova Scotia",
        options: __1.canadianCitiesLabelOnly.novaScotia,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Nunavut",
        options: __1.canadianCitiesLabelOnly.nunavut,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Ontario",
        options: __1.canadianCitiesLabelOnly.ontario,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Prince Edward Island",
        options: __1.canadianCitiesLabelOnly.princeEdwardIsland,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Quebec",
        options: __1.canadianCitiesLabelOnly.quebec,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Saskatchewan",
        options: __1.canadianCitiesLabelOnly.saskatchewan,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the name of the city in Yukon",
        options: __1.canadianCitiesLabelOnly.yukon,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Sibling first name(s)",
        tip: "Your brother or sister's first name (given name) and middle name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Sibling last name",
        tip: "Your brother or sister's last name (family name)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Sibling marital status",
        tip: "Your brother or sister's marital status",
        options: __1.maritalStatus,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Date of birth (DOB)",
        tip: "Your brother or sister's date of birth",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Sibling country of birth",
        tip: "What country was your brother or sister born in?",
        options: __1.maritalStatus,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Sibling full address",
        tip: "This should include street number, street name, city, country, postal code, etc.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Sibling current occupation",
        tip: "What job does your brother or sister have?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Sibling relationship",
        tip: "How are they related to you? A half-sibling means you share one birth parent. A step-sibling is where you are related only by marriage.",
        options: __1.siblingRelationship,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What day did you first come to Canada on?",
        tip: "Date of your original entry to Canada",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What city and province did you arrive in when you first came to Canada?",
        tip: "City and province of your original entry to Canada",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What was your original purpose for coming to Canada?",
        options: __1.purposeOfVisitComingToCanada,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Other original purpose for coming to Canada",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What day did you most recently come to Canada on?",
        tip: "If this is the same as your original entry date, you can leave this empty",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What city and province did you most recently arrive in when coming to Canada?",
        tip: "If this is the same as your original entry location, you can leave this empty",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Provide the document number of the most recent Visitor Record, Study Permit, Work Permit or Temporary Resident Permit issued to you",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the purpose of your visit?",
        options: __1.purposeOfVisit,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is the other purpose of your visit?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What type of work permit extension are you applying for?",
        options: __1.workPermitTypeInsideCanada,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What other type of work permit extension are you applying for?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is this business a recruitment or placement agency?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have an additional business operating name that you would like to include?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Additional business operating name",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Industrial sector",
        tip: "Please select which industry best applies to your business",
        options: __1.jobBankIndustry,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Type of business",
        options: __1.jobBankTypeOfBusiness,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Size of business",
        tip: "How many employees currently work for your business?",
        options: __1.jobBankSizeOfBusiness,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Learning opportunities being offered",
        tip: "Raise the interest of potential applicants by showing them how they will be able to learn, improve their skills and grow while working for your business. Select the options below that apply in your workplace.",
        options: __1.learningOpportunities,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Workplace accommodations being offered",
        tip: "Let job seekers with disabilities or medical needs know what kind of accommodations you have in place or are willing to put in place upon hiring. Select the options below that apply in your workplace.",
        options: __1.workplaceAccommodations,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Workplace amenities being offered",
        tip: "Inspire talents by letting potential applicants know what kind of amenities and activities your workplace has to offer. Select the options below that apply in your workplace.",
        options: __1.workplaceAmenities,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Green initiatives being offered",
        tip: "Provide potential applicants with a deeper insight into your business and tell them which green initiatives are in place to help the environment. Let them know about your plan to reduce the environmental impact of your business, and how they can help you achieve it. Select the options below that apply in your workplace.",
        options: __1.greenInitiatives,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many employees are employed nationally under your 9-digit CRA business number?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Did the business report more than $5 Million (CAD) in annual gross revenue to the CRA during its last tax year?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Does the business receive support through Employment Development Canada/Service Canada's Work-Sharing program?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Provide details regarding the support you are receiving through the Work-Sharing program",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is there a labour dispute in progress at any of the job offer work locations?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details regarding the labour dispute",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will hiring a TFW result in the direct job creation or job retention of Canadians/permanent residents?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details to explain why hiring a TFW will result in the direct job creation or job retention of Canadians/permanent residents",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will hiring a TFW result in the development or transfer of skills and knowledge for the benefit of Canadians/permanent residents?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details to explain why hiring a TFW will result in the development or transfer of skills and knowledge for the benefit of Canadians/permanent residents",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will hiring a TFW fill a labour shortage?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details to explain why hiring a TFW will fill labour shortage",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please describe any other benefits to the Canadian labour market that will result from offering this job to a TFW",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Thinking of the occupation into which you wish to hire a foreign worker, are there any employees currently working in this same occupation, with the same skills and years of experience, at the primary work location?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the lowest wage for these employees per hour?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the highest wage for these employees per hour?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many hours will the TFW work each day?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many hours will the TFW work each week?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will the TFW have an atypical schedule without standard daily or weekly hours?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details regarding the atypical schedules",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is your job offer for a full-time position (average of at least 30 hours per week) throughout the duration of employment covered by this Labour Market Impact Assessment?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Explain why your job offer is not full-time for the duration of employment covered by this LMIA",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is there an overtime rate?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the overtime wage in Canadian dollars per hour being offered to the TFW? (must meet provincial/territorial requirements)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Overtime will be determined by",
        options: __1.lmiaPortalOvertimeDetermined,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "After how many hours per week does the overtime rate begin?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will the TFW be paid any contingent wages (e.g. piecework, mileage, commissions, guaranteed bonuses, or predictable overtime)?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details about the contingent wages",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Describe, in your own words and in as much detail as possible, the main duties of the position offered to the TFW(s)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "How is the position requested in this application necessary for the operations of the business and explain the impact on your operations should the position remain vacant?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Does this position require the ability to communicate in a specific language?",
        options: __1.lmiaPortalLanguageCommunicateType,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "This position requires the ability to communicate orally in",
        options: __1.lmiaPortalLanguageCommunicate,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "This position requires the ability to communicate in writing in",
        options: __1.lmiaPortalLanguageCommunicate,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Does this position require the ability to communicate in a language other than English or French?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Indicate the other language required for the position and provide a rationale.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide a rationale to why the ability to communicate, as one of the two official languages should not be a minimum requirement.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Does this job have any minimum education requirements?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Indicate the minimum education requirements for this job",
        tip: "Select all that apply",
        options: __1.lmiaPortalMinimumEducationRequirements,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Describe the specific diploma/certificate, degree, Ph.D or other education requirements that the job requires",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "List any minimum experience/skills requirements of the job (include years of experience and/or occupational designations such as CPA, RN, P.Eng)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the occupation regulated at a federal/provincial/territorial level and does it require occupational certification, licensing or registration?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Indicate the type of occupational certification, licensing or registration required and the name of the issuing body/authority",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the position part of a union?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be providing any benefits to the TFW?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be providing disability insurance? ",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be providing dental insurance?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you enrol the TFW in an employer-provided pension?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be providing extended medical insurance? (e.g. prescription drugs, paramedical services, medical services and equipment)",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you be providing any other benefits?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "In the previous question, you indicated that there are other benefits. Please explain.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Enter the number of paid vacation days provided",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Enter the vacation pay percentage (of gross salary)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will the hiring of TFWs requested in this application lead to job losses, or a reduction in work hours, now or in the foreseeable future, for Canadians/permanent resident employees in your workforce or to the Canadian workforce more generally as a result of lay-offs including those resulting from outsourcing, off-shoring or other factors related to utilizing a TFW?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Provide details on the impact of hiring the TFW(s) on your workforce and the Canadian workforce more generally.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the regular (non-overtime) wage in Canadian dollars per hour being offered to the TFW?",
        tip: "You must provide the calculation of an hourly wage in $CAD, even if the position is salaried, paid in foreign currency, or paid by piecework.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Was the wage converted from a monthly, yearly or piecework salary, or a currency other than Canadian dollars, or both?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide a detailed explanation, including the calculations used if applicable, of how you converted the salary to Canadian dollars per hour",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "What is the business operating name of this location?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Describe, in your own words and in as much detail as possible, the principal business activity at this work location",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Describe, in your own words and in as much detail as possible, any safety concerns or hazards associated with the principal business activity or site",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is the expected employment duration determinant?",
        options: __1.lmiaPortalEmploymentDurationType,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the expected employment duration?",
        tip: "What is the number value based on the determinant above (number of years, days, months, etc)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "What is the expected employment start date?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In the last 12 months, did the employer lay off any employees working in the position(s) being requested in this application?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadians/permanent residents did you lay off in the last 12 months?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many TFWs (Temporary Foreign Workers) did you lay off in the last 12 months?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Provide reason(s) for the layoff(s)",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Wage Information",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Work Location Information",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Employment Duration Information",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Labour Market Impact",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you seeking to apply to Category A or Category B of the Global Talent Stream?",
        options: __1.lmiaPortalGtsCategory,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Select the Designated Referral Partner",
        options: __1.lmiaPortalDesignatedReferralPartner,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Select an occupation category from the list",
        options: __1.lmiaPortalGtsCategoryBOccupation,
    },
    // {
    //   inputType: QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
    //   question:
    //     "Please select the top 3-4 activities you'd like to commit to for the Labour Market Benefits Plan",
    //   options: ,// TODO:
    // },
    // {
    //   inputType: QUESTION_INPUT_TYPES.TEXTAREA,
    //   question: "Please provide estimates and/or values of how much you could commit to each activity",
    //   tip: 'for example, if you select hiring, mention how many staff you could commit to hiring per year'
    // },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Please indicate the arrival date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "Please indicate the departure date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Which of the following are you applying for?",
        tip: "Select the arrival type for the SAWP",
        options: __1.lmiaPortalSAWPArrivalType,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will substitute workers not be accepted in situations where previously identified workers are not available?",
        options: __1.yesNoOptions,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have any of the TFWs worked for 5 or more consecutive years at your place of employment?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will you provide a weekly recognition payment of between $4 and $128?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please explain why you are not providing a weekly recognition payment",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total number of Canadian/permanent resident workers in the same occupation working at the same location expected to be employed this year/season",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total number of Canadian/permanent resident workers in the same occupation working at the same location employed last year/season",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total number of TFWs in the same occupation working at the same location expected to be employed this year/season",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Total number of TFWs in the same occupation working at the same location employed last year/season",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Did the number of workers, which includes Canadian citizens, permanent residents and TFWs change from last year/season?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "In the previous question, you indicated that the number of workers changed from last year/season. Please explain:",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is this LMIA application for replacement workers?",
        tip: "Request to replace worker(s) who left prior to the expected employment end date",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Enter the LMIA # you are requesting replacement TFWs for",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "For the LMIA # entered, how many of the requested TFWs are currently employed?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you providing on-farm or off-farm housing?",
        options: __1.lmiaPortalOffFarmOnFarmHousing,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How much will you deduct per week?",
        tip: "A maximum of $30 per week (pro-rated for partial weeks) can be deducted from the TFW's wage, unless applicable provincial/territorial labour standards specify a lower amount.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the occupation in which the TFW will work a lower-skilled or higher-skilled occupation?",
        options: __1.lmiaPortalOffFarmHousingSkilled,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many TFWs is the Market Rental Rate being divided between?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the Market Rental Rate per month?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the rent per TFW per month?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the position subject to a variation in minimum advertising requirements as listed on the TFW Program website, including the Quebec Facilitated Process?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Specify the applicable variation and provide a rationale for meeting its criteria",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "In addition to applying for the recruitment variation, would you like to provide any recruitment details for this application?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Did you advertise using Job Bank?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Please enter the job posting number advertised on Job Bank",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Provide an explanation of the advertising method and a rationale for not utilizing Job Bank",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many applications/resumes were received from Canadians/permanent residents?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadians/permanent resident applicants were interviewed?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadians/permanent residents were offered the position?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadians/permanent residents were hired?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadians/permanent residents declined a job offer?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadians/permanent residents applied but were not interviewed or offered the position?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "For each unsuitable Canadian/permanent resident applicant, provide an explanation as to why the candidate did not meet the requirements of the position. Do not provide the names of the candidates.",
        tip: "Example: applicant #1 has not completed the apprenticeship program and therefore cannot work as a journeyperson, applicant #2 – is unable to communicate in English to the level required for technical salesperson of medical equipment.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you applying for an LMIA to support a TFW?",
        options: __1.lmiaPortalSupportTFW,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is this application being made jointly with another employer?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Who is currently filling the duties and responsibilities of the position?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "How did you find or identify the TFW for this position?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you previously employed or do you currently employ any of these TFW on an LMIA-based work permit or an LMIA-exempt work permit?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please indicate the start and end dates of any periods when you employed these TFW. Also indicate the start and end dates of any breaks in employment.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "How did you determine that the TFW possessed the qualifications for the job?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "How and when did you offer this job to the TFW(s)?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will more than one individual act as the employer of the TFW?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Middle name",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the contact number North American?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is there an alternate telephone #?",
        options: __1.lmiaPortalCaregiverAlternatePhone,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Language of correspondence",
        options: __1.lmiaPortalCaregiverLanguageCorrespondence,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Address Line 1",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Address Line 2",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Second Employer Physical Address",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Second Employer Mailing Address",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the mailing address the same as the physical address?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Financial Ability",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Enter the declared income of the second employer as per line 150 of the CRA Notice of Assessment",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Does the second employer live in the same household as the first employer?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Enter the declared income of the second employer as per line 150 of the CRA Notice of Assessment",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Locate the LICO figure that applies to the second employer's household and input it",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Enter the declared income of the first employer as per line 150 of the CRA Notice of Assessment",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Locate the LICO figure that applies to the first employer's household and input it",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Enter the total annual wage to be paid to the foreign caregiver",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is there additional income available to pay the TFW that was not declared on line 150 of the CRA Notice of Assessment (e.g. savings or provincial grants) from either the first or second employer (if applicable)?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please specify the specific type(s) and amount(s) of supplementary available income",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Care Required",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many people is the employer responsible for financially supporting (i.e. dependents)? Consider dependents of both employers if applicable, including any dependents not living in the household",
        tip: "e.g. students away from home attending school",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you providing accommodations for the TFW in the home where the care will be provided?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the live-in arrangement voluntary?",
        tip: "An agreement between you and the foreign worker, as a means to assist the foreign worker, or is it a mandatory requirement of the job",
        options: __1.lmiaPortalCaregiverLiveArrangementVoluntary,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Will the TFW have their own bedroom?",
        tip: "Note: This is a program requirement",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the length of the bedroom in feet (ft)?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the width of the bedroom in feet (ft)?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Provide additional details about furniture and/or services",
        tip: "e.g. telephone, television, cable or satellite, internet, etc.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Does the bedroom that will be provided to the TFW include",
        options: __1.lmiaPortalCaregiverBedroomFeatures,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please explain why the TFW will not have their own bedroom",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is this LMIA application for a seasonal occupation?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What month does your peak employment season start in every year?",
        tip: "What month of the year does your peak employment usually start in?",
        options: __1.lmiaPortalMonths,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What month does your peak employment season end in every year?",
        tip: "What month of the year does your peak employment usually end in?",
        options: __1.lmiaPortalMonths,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What was your total number of Canadian/permanent resident workers during the previous peak season?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What was your total number of TFWs during the previous peak season?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many Canadians/permanent residents are currently employed in the occupation at the work location?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many TFWs are currently employed in the occupation at the work location?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "A transition plan is mandatory for employers hiring TFWs with a rate of pay equal to or above the provincial/territorial median wage. Do you wish to be considered for an exemption from the transition plan requirement?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What are the transition plan exemption criteria you wish to be considered for?",
        options: __1.lmiaPortalTransitionPlanExemptionTypes,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Please provide details to support your request for an exemption",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Have you completed a Transition Plan for this occupation at this work location before?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Describe the results of your previous transition plan activities",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Is the occupation for which you are submitting an LMIA on the list of occupations eligible for Quebec's facilitated process and indicates a wage equal to or greater than the provincial median hourly wage?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Select the type of job that suits your recruitment needs",
        options: __1.jobBankJobType,
        tip: "The default position can be filled by any candidate meeting the hiring criteria outlined in the job posting, with no specific status requirements (students or apprentices).",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Target groups",
        tip: "Market your job to specific groups of job seekers. They can use the following options as job search filters.",
        options: __1.jobBankTargetGroups,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Who can apply to this job?",
        options: __1.jobBankWhoCanApply,
        tip: "Select the category of applicants you want to recruit for this job.",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Indicate the number of people you are looking to hire",
        tip: "Number of job vacancies",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Workplace information",
        options: __1.jobBankWorkplaceInformation,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "Posting duration",
        tip: "How many days should this job posting be posted for?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Period of employment",
        options: __1.jobBankPeriodOfEmployment,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Job start date",
        options: __1.jobBankStartDateType,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.DATE,
        question: "End date",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Hours of work",
        options: __1.jobBankHoursOfWork,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Would you like to specify the work hours?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "Start time",
        tip: "Format using 24 hour clock with increments of 30 minutes, e.g. 07:30",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "End time",
        tip: "Format using 24 hour clock with increments of 30 minutes, e.g. 07:30",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Employment terms options",
        options: __1.jobBankEmploymentTermOptions,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "What is the monthly salary in CAD?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.NUMBER,
        question: "How many hours will they be required to work per week?",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Health benefits",
        options: __1.jobBankHealthBenefits,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Financial benefits",
        options: __1.jobBankFinancialBenefits,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Long term benefits",
        options: __1.jobBankLongTermBenefits,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Other benefits",
        options: __1.jobBankOtherBenefits,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "If this is a green job, please select all answers that apply",
        options: __1.jobBankGreenJob,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.HEADING,
        question: "Requirements",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Work setting",
        options: __1.jobBankWorkSetting,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Budgetary responsibility",
        options: __1.jobBankBudgetaryResponsibility,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Tasks",
        options: __1.jobBankTasks,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Supervision",
        options: __1.jobBankSupervision,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Computer and technology knowledge",
        options: __1.jobBankComputerTechKnowledge,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Area of specialization",
        options: __1.jobBankAreaSpecialization,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Security and safety",
        options: __1.jobBankSecuritySafety,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Transportation/travel information",
        options: __1.jobBankTransportationTravel,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Work conditions and physical capabilities",
        options: __1.jobBankWorkConditionsPhysical,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Personal suitability",
        options: __1.jobBankPersonalSuitability,
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Select the minimum level of education needed for this job",
        options: __1.jobBankEducationRequirement,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "How much experience is required?",
        options: __1.jobBankExperienceRequirement,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What official language(s) are required?",
        options: __1.jobBankLanguageRequirement,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXT,
        question: "External job posting website URL",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "How-to-apply instructions",
        options: __1.jobBankApplyInstructions,
        tip: "You can add one or several instructions to guide candidates when applying, and specify your needs for the recruitment process.",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.MULTI_CHECKBOX,
        question: "Screening questions",
        options: __1.jobBankScreeningOptions,
        tip: "Select the screening questions applicants must answer to meet the minimum requirements of this job posting.",
        validationRules: null,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Would you like to add a second authorized representative?",
        options: __1.yesNoOptions,
        tip: "The secondary person of contact is someone who is also allowed to sign agreements on behalf of the company, as the immigration application requires a second signature. This can be anyone at the company with signing authority (e.g. Head of Talent, Head of HR, CTO, CEO, CFO, etc).",
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you current have immigration status in Canada?",
        tip: "For example, your currently are on a Canadian work permit, or have Canadian permanent residency status",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you currently have immigration status in Canada?",
        tip: "For example, your currently are on a Canadian work permit, or have Canadian permanent residency status",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is your current immigration status in Canada?",
        options: __1.residenceStatusOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What are you most interested in applying for in Canada?",
        options: __1.residenceStatusOptionsTransformed,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "How many years of paid or skilled work experience do you have outside of Canada in the last 10 years?",
        options: __1.yearsOfWorkExperience,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "How many years of paid Canadian work experience do you have in the last 10 years?",
        tip: "This must be paid legal work",
        options: __1.yearsOfWorkExperience,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What industry is your primary work experience in?",
        options: __1.primaryWorkExperienceSector,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Do you have a job offer from a Canadian company?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Are you a strong French speaker?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "What is your highest completed level of education?",
        options: __1.highestLevelEducationCompleted,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.SELECT,
        question: "Did you complete any of your education in Canada?",
        options: __1.yesNoOptions,
    },
    {
        inputType: question_input_types_1.QUESTION_INPUT_TYPES.TEXTAREA,
        question: "Do you have any other comments, notes or questions you'd like to tell us about?",
        options: __1.yesNoOptions,
        validationRules: null,
    },
];
exports.questions = exports.INDIVIDUAL_QUESTION_DEFINITIONS.map(({ question }) => question);
class SeedQuestion {
    constructor(question) {
        this._layout = undefined;
        this._renderIf = [];
        this.dependantQuestions = [];
        this.ifAnswerEquals = (answer) => {
            const newObj = new SeedQuestion(this);
            return {
                renderTheseQuestions: (questions) => {
                    newObj.dependantQuestions = [
                        ...newObj.dependantQuestions,
                        ...questions.map((question) => question.renderIf(answer, this)),
                    ];
                    return newObj;
                },
            };
        };
        this.renderIf = (answer, question, isFormScope) => {
            const newObj = new SeedQuestion(this);
            const condition = [answer, "===", question];
            if (isFormScope)
                condition.push("FORM");
            newObj._renderIf = [...newObj._renderIf, condition];
            return newObj;
        };
        this.question = question.question;
        this.inputType = question.inputType;
        this.options = question.options;
        this.validationRules = question.validationRules;
        this._label = question._label;
        this._renderIf = question._renderIf || [];
        this.dependantQuestions = question.dependantQuestions || [];
        this.tip = question.tip || undefined;
    }
    label(label) {
        const newObj = new SeedQuestion(this);
        newObj._label = label;
        return newObj;
    }
    layout(layout) {
        const newObj = new SeedQuestion(this);
        newObj._layout = layout;
        return newObj;
    }
    toJSON() {
        return {
            question: this.question,
            label: this._label,
            inputType: this.inputType,
            options: this.options,
            layout: this._layout,
            renderIf: this._renderIf,
            dependantQuestions: this.dependantQuestions,
            validationRules: this.validationRules,
            tip: this.tip,
        };
    }
}
exports.SeedQuestion = SeedQuestion;
const _Question = exports.INDIVIDUAL_QUESTION_DEFINITIONS.reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr.question]: new SeedQuestion(curr) })), {});
const handler = {
    get: function (target, prop) {
        if (target[prop])
            return target[prop];
        throw new Error(`Question ${prop} does not exist`);
    },
};
exports.Question = new Proxy(_Question, handler);
